export default {"src":"/_next/static/media/capblue.07fd9f4b.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};